'use client';

import { useLocalizedLinks } from '@/components/core/hooks';
import { categories } from '@/@constants';
import { FeedType } from '@/@types';
import { Trans } from '@lingui/react/macro';
import { UIComponent } from '@/components/core/components';
import { Element, Image, Scrollable } from '@/components/core/components/atoms';
import InternalLink from '@/components/core/components/organism/internal-link';
import Feed from '@/components/core/components/organism/feed';
import * as styles from './carousel-feed.styles';

const CarouselFeed: UIComponent<{ items: FeedType[]; limit?: number; loading?: boolean; step?: number; snap?: boolean; seeMore?: string }> = ({
  items,
  className,
  limit = 5,
  loading,
  step = 160,
  snap,
  seeMore,
}) => {
  const links = useLocalizedLinks();

  return (
    <Scrollable className={className} step={step} snap={snap}>
      <div className={styles.root}>
        {loading ? (
          Array(limit)
            .fill(0)
            .map((_, i) => {
              // eslint-disable-next-line react/no-array-index-key
              return <Feed.Loading key={i} />;
            })
        ) : (
          <>
            {items.slice(0, limit).map((item) => {
              return (
                <InternalLink href={links.product(item.product)} key={item.product.id}>
                  <Feed.Background
                    sizes={['320px']}
                    withoutOverlay
                    media={item.product.media}
                    squareMiniature={item.product.category.name === categories.music.name}
                  />
                  <span className={styles.name}>
                    <Element lines={2}>{item.product.name}</Element>
                  </span>
                </InternalLink>
              );
            })}
            {seeMore && (
              <InternalLink href={seeMore}>
                <Feed.Background className={styles.seeMore} withoutOverlay>
                  <div className={styles.seeMoreGrid}>
                    {items
                      .slice(limit, limit + 4)
                      .filter((item) => {
                        return item.product.media.at(0)?.source;
                      })
                      .map((item) => {
                        return <Image key={item.product.id} src={item.product.media.at(0)!.source} sizes={['80']} alt="See more" />;
                      })}
                  </div>
                  <span>
                    <Trans>See more</Trans>
                  </span>
                </Feed.Background>
              </InternalLink>
            )}
          </>
        )}
      </div>
    </Scrollable>
  );
};

export default CarouselFeed;
